exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".atom-image{padding:0.5rem;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;-ms-flex-negative:1;flex-shrink:1;position:relative;border-top:1px solid #ddd}.atom-image__image_thumb{width:50%;display:table-cell;vertical-align:middle;margin:auto}\n", ""]);

// exports
